import { useMemo } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@commenda/kakashi';

import { IndirectTaxRegion } from '../../common';
import { IndirectTaxTransactionsDashboard } from '../../transactions/dashboard';
import { IndirectTaxFilingsHelper } from '../helpers';
import { IIndirectTaxFilingDetail } from '../types';

interface IndirectTaxFilingViewTransactionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  filing: IIndirectTaxFilingDetail;
  region: IndirectTaxRegion;
  corporationId: number;
  companyId: number;
}

const IndirectTaxFilingViewTransactionsModal = ({
  isOpen,
  onClose,
  filing,
  region,
  corporationId,
  companyId,
}: IndirectTaxFilingViewTransactionsModalProps) => {
  const initialFilters = useMemo(
    () => IndirectTaxFilingsHelper.buildTransactionFiltersForFiling(filing, region),
    [filing, region]
  );

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className="bg-white p-none flex flex-col w-[95vw] max-w-[95vw] h-[95vh] max-h-[95vh] overflow-hidden"
        preventCloseOnOutsideClick
      >
        <DialogHeader className="px-3xl pt-3xl">
          <DialogTitle>Filing transactions</DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-auto">
          {isOpen ? (
            <IndirectTaxTransactionsDashboard
              key={filing.id}
              header={null}
              corporationId={corporationId}
              companyId={companyId}
              initialState={{ filters: initialFilters, region }}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { IndirectTaxFilingViewTransactionsModal };
